import React, { useState, useContext, useEffect } from "react";
import { UpsellRoutes } from "./../../Routes";
import { NavLink } from "reactstrap";
import { NavLink as NavLinkRRD, useLocation } from "react-router-dom";
import { ProductContext } from "../../store";
import Skeleton from "react-loading-skeleton";

const UpsellSidebar = () => {
	const [subMenuOpen, setSubMenuOpen] = useState([]);
	const [websitePlatform, setWebsitePlatform] = useState("");
	const location = useLocation()
	const {
		addPageOpen,
		userLoader,
		websiteData,
		currentWebsiteId,
		userWebsitePlan,
		productTypes
	} = useContext(ProductContext);

	useEffect(() => {
		if (userLoader || !userWebsitePlan || !Array.isArray(userWebsitePlan) || userWebsitePlan.length === 0) {
			return
		}
		if (currentWebsiteId) {
			setWebsitePlatform(websiteData[currentWebsiteId]?.websiteType)
		}
	}, [currentWebsiteId, userLoader, userWebsitePlan])

	const handleTopMenu = (e, upsellRoute) => {
		if (location.pathname && upsellRoute.path && location.pathname !== upsellRoute.layout + upsellRoute.path) {
			return
		}
		if (!upsellRoute.path) {
			e.preventDefault()
		}
		if (subMenuOpen.indexOf(upsellRoute.name) > -1) {
			setSubMenuOpen(subMenuOpen.filter(item => item !== upsellRoute.name))
		} else {
			setSubMenuOpen([...subMenuOpen, upsellRoute.name])
		}
	}

	return (
		<div className="innerSideBarContainer" style={{ display: addPageOpen ? 'none' : 'flex' }} >
			<header className="inner-header text-center align-items-center justify-content-start d-flex">
				<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="stl-text-grey-400 stl-ml-[-3px] stl-shrink-0">
				<path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z">
					</path>
					</svg>
					<div style={{ marginLeft: '12px' }}>
					<text x="12" y="22" fill="currentColor" fontSize="8" fontFamily="Arial, sans-serif" fontWeight="600" text-anchor="middle">Recommendation</text>
					</div>
			</header>
			{websitePlatform === "" ?
				<>
					<Skeleton height={10} />
					<Skeleton height={10} />
					<Skeleton height={10} />
					<Skeleton height={10} />
					<Skeleton height={10} />
					<Skeleton height={10} />
					<Skeleton height={10} />
					<Skeleton height={10} />
					<Skeleton height={10} />
					<Skeleton height={10} />
					<Skeleton height={10} />
				</>
				:
				<nav aria-label="Upsell Navigation">
					<ul className="searchNavigationList">
						{UpsellRoutes.map((upsellRoute, index) => {
							return (
								<React.Fragment key={index}>
									{((!upsellRoute.accessPlans || ( upsellRoute.accessPlans && userWebsitePlan && Array.isArray(userWebsitePlan) && userWebsitePlan.some(plan => upsellRoute.accessPlans.includes(plan.planId)) ) ) && ( !upsellRoute.availablePlatforms || ( upsellRoute.availablePlatforms && upsellRoute.availablePlatforms.includes(websitePlatform) ) ) && ( !upsellRoute.productType || ( upsellRoute.productType && productTypes.includes(upsellRoute.productType) ) ) ) && (
										<li key={index}>
											<NavLink
												to={upsellRoute.path ? upsellRoute.layout + upsellRoute.path : "#"}
												tag={NavLinkRRD}
												className={`navItem ${upsellRoute.itemClass ? upsellRoute.itemClass : ""}`}
												activeClassName="active"
												onClick={(e) => handleTopMenu(e, upsellRoute)}
											>
												<div className="d-flex align-items-center justify-content-between">
													<div className="iconStringWrap">
														<i className={`fas ${upsellRoute.fontIcon} text-white`} style={{ fontSize: "14px", marginRight: "8px" }}></i>
														{upsellRoute.name}
													</div>
													{upsellRoute.subMenu && upsellRoute.subMenu.length > 0 &&
														<i className={`fas ${subMenuOpen.indexOf(upsellRoute.name) === -1 ? "fa-chevron-down" : "fa-chevron-right"}`} style={{ fontSize: "10px" }} />
													}
												</div>
											</NavLink>
											{subMenuOpen.indexOf(upsellRoute.name) === -1 && upsellRoute.subMenu && upsellRoute.subMenu.length > 0 &&
												<div id={"linkGroup" + (index + 1)} className="linkGroup">
													<ul>
														{upsellRoute.subMenu.map((subMenu, index) => {
															if (subMenu.menuFlag && (!subMenu.availablePlatforms || (subMenu.availablePlatforms && subMenu.availablePlatforms.includes(websitePlatform)))) {
																return (
																	<li key={index}>
																		<NavLink
																			to={subMenu.layout + subMenu.path}
																			tag={NavLinkRRD}
																			className={`navItem ${subMenu.itemClass ? subMenu.itemClass : ""}`}
																			activeClassName="active"
																			onClick={(e) => e.stopPropagation()}
																		>
																			{subMenu.name}
																		</NavLink>
																	</li>
																)
															}
															return null
														})}
													</ul>
												</div>
											}
										</li>
									)}
								</React.Fragment>
							)
						})}
					</ul>
				</nav>
			}
		</div>
	);
};

export default UpsellSidebar;
